/**
 * Mobile header: keep logo/search stuck, let the address bar scroll away.
 * Sticky top offset = minus address height so only the middle chrome remains.
 */
const MQ_MOBILE = '(max-width: 991px)';

export function initMobileHeader() {
  const header = document.getElementById('mobileheader');
  if (!header) {
    return;
  }

  const address = header.querySelector('.mobile-header__address');
  const mq = window.matchMedia(MQ_MOBILE);

  const sync = () => {
    if (!mq.matches) {
      header.style.removeProperty('--mobile-address-height');
      return;
    }

    const height = address instanceof HTMLElement ? address.offsetHeight : 0;
    header.style.setProperty('--mobile-address-height', `${Math.round(height)}px`);
  };

  if (header.dataset.mobileHeaderInited === '1') {
    sync();
    return;
  }

  header.dataset.mobileHeaderInited = '1';
  sync();

  if (typeof ResizeObserver !== 'undefined' && address instanceof HTMLElement) {
    const observer = new ResizeObserver(sync);
    observer.observe(address);
  }

  window.addEventListener('resize', sync, { passive: true });
  if (typeof mq.addEventListener === 'function') {
    mq.addEventListener('change', sync);
  } else if (typeof mq.addListener === 'function') {
    mq.addListener(sync);
  }
}
